import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function Hero() {
  return <Box sx={{ bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider', py: { xs: 6, md: 9 } }}>
    <Container maxWidth="md">
      <Typography variant="h1" component="h1" sx={{ mb: 2 }}>Chem Lab Skills</Typography>
      <Typography sx={{ mb: 3 }}>Explore chemistry through lab instructions, diagrams, and practice questions.</Typography>
      <Typography sx={{ mb: 3 }}>Work at your own pace. Your answers stay in this browser; no account is needed.</Typography>
      <Button component={Link} to="/labs" variant="contained">View labs</Button>
    </Container>
  </Box>;
}
